import { useEffect, useState } from "react"

export type EmbeddedChatBreakpoint = "desktop" | "tablet" | "mobile"

const DESKTOP_BREAKPOINT = 1000
const TABLET_BREAKPOINT = 500

function getBreakpoint(width: number): EmbeddedChatBreakpoint {
  if (width >= DESKTOP_BREAKPOINT) return "desktop"
  if (width >= TABLET_BREAKPOINT) return "tablet"
  return "mobile"
}

export function useEmbeddedChatBreakpoint(): EmbeddedChatBreakpoint {
  const [breakpoint, setBreakpoint] = useState<EmbeddedChatBreakpoint>(() => {
    if (typeof window === "undefined") return "desktop"
    return getBreakpoint(window.innerWidth)
  })

  useEffect(() => {
    const handleResize = () => {
      setBreakpoint(getBreakpoint(window.innerWidth))
    }

    // Set initial value
    handleResize()

    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return breakpoint
}
